(function () {
  var activeNav = null;

  function getHeader(trigger) {
    return trigger.closest('[data-section-type="header"].site-header--unified');
  }

  function getOpenNavigation() {
    return document.querySelector('.header-navigation.header-navigation--open');
  }

  function resetMobileSubmenus(nav) {
    if (!nav) return;

    nav.querySelectorAll('.mobile-site-nav__item--expandable.is-open').forEach(function (item) {
      item.classList.remove('is-open');
      var toggle = item.querySelector('.mobile-site-nav__toggle');
      var submenu = item.querySelector('.mobile-site-nav__submenu');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      if (submenu) submenu.hidden = true;
    });
  }

  function attachNavToBody(nav) {
    if (!nav.__mobileMenuAnchor) {
      nav.__mobileMenuAnchor = {
        parent: nav.parentNode,
        next: nav.nextSibling
      };
    }

    document.body.appendChild(nav);
  }

  function restoreNavPosition(nav) {
    var anchor = nav && nav.__mobileMenuAnchor;

    if (!anchor || !anchor.parent) {
      return;
    }

    if (anchor.next && anchor.next.parentNode === anchor.parent) {
      anchor.parent.insertBefore(nav, anchor.next);
    } else {
      anchor.parent.appendChild(nav);
    }
  }

  function openMenu(header) {
    var nav = header.querySelector('.header-navigation');

    if (!nav || activeNav) {
      return;
    }

    activeNav = nav;
    attachNavToBody(nav);

    document.body.classList.add('mobile-menu-open');
    document.body.classList.remove('search-bar-open', 'search-bar-in-focus');
    nav.classList.add('header-navigation--open');
  }

  function closeMenu() {
    var nav = getOpenNavigation();

    if (!nav) {
      activeNav = null;
      document.body.classList.remove('mobile-menu-open');
      return;
    }

    resetMobileSubmenus(nav);
    nav.classList.remove('header-navigation--open');
    document.body.classList.remove('mobile-menu-open');
    restoreNavPosition(nav);
    activeNav = null;
  }

  function toggleMobileSubmenu(item) {
    var isOpen = item.classList.contains('is-open');
    var nav = item.closest('.header-navigation');
    resetMobileSubmenus(nav);

    if (isOpen) {
      return;
    }

    var toggle = item.querySelector('.mobile-site-nav__toggle');
    var submenu = item.querySelector('.mobile-site-nav__submenu');

    item.classList.add('is-open');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    if (submenu) submenu.hidden = false;
  }

  document.addEventListener('click', function (event) {
    var openTrigger = event.target.closest('.js-mobile-menu-icon');
    if (openTrigger) {
      var header = getHeader(openTrigger);
      if (header) {
        event.preventDefault();
        event.stopImmediatePropagation();
        openMenu(header);
      }
      return;
    }

    var closeTrigger = event.target.closest('.js-close-mobile-menu');
    if (closeTrigger) {
      if (getHeader(closeTrigger) || getOpenNavigation()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        closeMenu();
      }
      return;
    }

    var expandableRow = event.target.closest('.mobile-site-nav__item--expandable > .mobile-site-nav__row');
    if (expandableRow) {
      var item = expandableRow.closest('.mobile-site-nav__item--expandable');
      if (item) {
        event.preventDefault();
        event.stopPropagation();
        toggleMobileSubmenu(item);
      }
    }
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' || !document.body.classList.contains('mobile-menu-open')) {
      return;
    }

    closeMenu();
  });
})();
